import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'
import FareConditionsInit from 'initializations/pages/FareConditions'

export class Main extends AbstractView {
  constructor(domElementId) {
    return super(domElementId);
  }

  init() {
    FareConditionsInit.init("fareConditions")

    const FareConditionsPage = () => import(/* webpackChunkName: "fare-conditions" */ 'containers/Pages/FareConditions')

    new Vue({
      el: "#" + this.elemId,
      store,
      render: h => h(FareConditionsPage)
    })
  }
}